import React from "react";
import Frame from "../../assests/Frame.png";
import { Search } from "lucide-react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import RuleTableHead from "./RuleTableHead";
import RuleTableBody from "./RuleTableBody";
import PaginationBar from "./PaginationBar";


const Tables = ({
  tableData = [],
  pagination = {},
  onPageChange,
  onExport,
  loading = false,
  error = null,
  onSearchChange,
  onColumnFiltersChange,
}) => {
  const [columnSearch, setColumnSearch] = React.useState({
    ruleId: "",
    ruleName: "",
    description: "",
    dqDimension: "",
    checkType: "",
    rulePhase: "",
    category: "",
    threshold: "",
    remediationAction: "",
    owner: "",
    status: "",
    allsearch: "",
    keywords: "",
  });
  const [isSearching, setIsSearching] = React.useState(false)
  const tableContainerRef = React.useRef(null);

  const highlightMatch = (text = "", searchTerm = "") => {
    if (!searchTerm.trim()) return text;

    const regex = new RegExp(`(${searchTerm})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, i) =>
      regex.test(part) ? (
        <span
          key={i}
          style={{
            backgroundColor: "orange",
            borderRadius: "2px",
            padding: "0 2px",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const currentPage = pagination?.currentPage ?? 1;
  const pageSize = pagination?.pageSize ?? 10;
  const totalRecords = pagination?.totalRecords ?? tableData.length;
  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));

  const indexOfFirstRow = (currentPage - 1) * pageSize;
  const indexOfLastRow = Math.min(indexOfFirstRow + pageSize, totalRecords);

  const gotoPage = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange && onPageChange(page);
  };
  React.useEffect(() => {
    setIsSearching(loading);
  }, [loading]);
  return (
    <div className="poppins-regular">

      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <div className="relative w-[200px] mt-[6px] flex-shrink-0">
        <input
  type="text"
  className="text-[9px] placeholder-gray-400 py-2 pl-[10px] w-full outline-none border border-gray-500 rounded"
  placeholder="Search..."
  value={columnSearch.allsearch}
  onChange={(e) => {
    const value = e.target.value;
    setColumnSearch({ ...columnSearch, allsearch: value }); 
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      setIsSearching(true);
      onSearchChange(columnSearch.allsearch); 
      setTimeout(() => setIsSearching(false), 800);
    }
  }}
/>


            <Search
              size={14}
              color="#9CA3AF"
              className="absolute right-[8px] top-1/2 -translate-y-1/2 pointer-events-none"
            />
          </div>

          <button className="px-3 mt-[4px] py-1 text-gray-700 bg-white border border-gray-300 rounded"
            onClick={() => {
              const clearedFilters = {
                ruleId: "",
                ruleName: "",
                description: "",
                dqDimension: "",
                checkType: "",
                rulePhase: "",
                category: "",
                threshold: "",
                remediationAction: "",
                owner: "",
                status: "",
                allsearch: ""
              };

              setColumnSearch(clearedFilters);
              onSearchChange("");
              onColumnFiltersChange(clearedFilters);
            }}>
            Reset
          </button>

          <div className="flex items-center gap-1 mt-[2px]">
            <ChevronLeft
              title="Scroll Left"
              className="cursor-pointer"
              onClick={() => {
                if (tableContainerRef.current) {
                  tableContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
                }
              }}
            />
            <p className="text-[12px]">Scroll</p>
            <ChevronRight
              className="cursor-pointer"
              title="Scroll Right"
              onClick={() => {
                if (tableContainerRef.current) {
                  tableContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
                }
              }}
            />
          </div>

        </div>

        <div
          className="flex gap-1 items-center mb-2 cursor-pointer pt-[10px] pr-[10px]"
          onClick={onExport}
        >
          <img src={Frame} alt="Export icon" />
          <p className="text-[#080AA7]">Export Data</p>
        </div>
      </div>
      <div
        ref={tableContainerRef}
        style={{ overflowX: "auto", scrollBehavior: "smooth" }}
      >
        <table className="rules-tables" style={{ marginTop: "2rem" }}>
          <RuleTableHead
            columnSearch={columnSearch}
            setColumnSearch={setColumnSearch}
            setIsSearching={setIsSearching}
            onSearchChange={onSearchChange}
            onColumnFiltersChange={onColumnFiltersChange}
          />
          <RuleTableBody
            tableData={tableData}
            isSearching={isSearching}
            columnSearch={columnSearch}
            highlightMatch={highlightMatch}
          />
        </table>
      </div>
      <PaginationBar
        totalRecords={totalRecords}
        indexOfFirstRow={indexOfFirstRow}
        indexOfLastRow={indexOfLastRow}
        currentPage={currentPage}
        totalPages={totalPages}
        gotoPage={gotoPage}
        maxPagesToShow={5}
      />
    </div>
  );
};
export default Tables;
